module.exports = __webpack_public_path__ + "static/fonts/Lato-Regular.f844c058.ttf";